//Proofed
import { useEffect } from 'react'
import { Dialog, DialogContent, IconButton, Box, Typography, Stack, CircularProgress } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { COLOR_PRIMARY } from '../theme'
import { DEMO_BOOKING_URL, loadDemoBookingScript } from '../common/common'

interface BookDemoModalProps {
    open: boolean
    onClose: () => void
    title?: string
}

// Initial space while the widget loads; the embed script then sets the real height
const MIN_CONTENT_HEIGHT = 420

export function BookDemoModal({ open, onClose, title = "Discovery Call with CFP" }: BookDemoModalProps) {
    // The booking widget resizes its iframe via this script, so it must load after the iframe mounts
    useEffect(() => {
        if (open) loadDemoBookingScript()
    }, [open])

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: { borderRadius: 2, overflow: 'hidden' },
            }}
        >
            <Box sx={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                px: 3, py: 2,
                borderBottom: '1px solid rgba(0,0,0,0.08)',
            }}>
                <Typography component="h2" sx={{ m: 0, fontWeight: 700, fontSize: { xs: '20px', md: '25px' } }}>
                    {title}
                </Typography>
                <IconButton onClick={onClose} size="small" sx={{ color: 'text.secondary' }}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Box>
            <DialogContent sx={{ p: 0, maxHeight: '80vh', overflow: 'auto' }}>
                {open && (
                    /* The embed script hides the iframe until the widget reports ready, so the
                       wrapper holds the space and the spinner sits behind the iframe */
                    <Box sx={{ position: 'relative', minHeight: MIN_CONTENT_HEIGHT }}>
                        <Stack
                            alignItems="center"
                            spacing={2}
                            sx={{ position: 'absolute', inset: 0, pt: 8 }}
                        >
                            <CircularProgress sx={{ color: COLOR_PRIMARY }} />
                            <Typography color="text.secondary">Loading the booking calendar...</Typography>
                        </Stack>
                        <Box
                            component="iframe"
                            src={DEMO_BOOKING_URL}
                            id="nqDvluEGCng5KAEtPCqv_modal"
                            title={title}
                            scrolling="no"
                            allow="payment"
                            sx={{
                                position: 'relative', zIndex: 1, width: '100%', minHeight: MIN_CONTENT_HEIGHT,
                                border: 'none', display: 'block', backgroundColor: 'white',
                            }}
                        />
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    )
}
